import theme_icons from "../../icons.js";
import external_link_icon from "../../../assets/block-icons/up-right-from-square-solid.svg";
import forest_bottom_graphic from "../../../assets/block-icons/forest-bottom.svg";

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { RichText, InspectorControls, InnerBlocks } = wp.blockEditor;
const { PanelBody, SelectControl, TextControl, ToggleControl } =
    wp.components;

const latestpostscta = {
    title: "Latest Posts CTA Layout",
    icon: theme_icons.greenheart,
    category: "greenheart",

    supports: {
        align: ["wide", "full"],
    },

    attributes: {
        backgroundGraphic: {
            type: "string",
            default: "forest",
        },

        title: {
            type: "string",
            default: "",
        },

        subtitle: {
            type: "string",
            default: "",
        },

        tagline: {
            type: "string",
            default: "",
        },

        url: {
            type: "string",
            default: "",
        },

        isDownload: {
            type: "boolean",
            default: false,
        },
    },

    edit({ attributes, setAttributes }) {
        const {
            backgroundGraphic,
            title,
            subtitle,
            tagline,
            url,
            isDownload,
        } = attributes;

        return (
            <>
                <InspectorControls>
                    <PanelBody title="Layout Settings">

                        <SelectControl
                            label="Background Graphic"
                            value={backgroundGraphic}
                            options={[
                                { label: "Forest", value: "forest" },
                                { label: "Ocean", value: "ocean" },
                            ]}
                            onChange={(val) =>
                                setAttributes({ backgroundGraphic: val })
                            }
                        />

                        <TextControl
                            label="CTA URL"
                            value={url}
                            onChange={(val) =>
                                setAttributes({ url: val })
                            }
                        />

                        <ToggleControl
                            label="Enable Download Mode"
                            checked={isDownload}
                            onChange={() =>
                                setAttributes({ isDownload: !isDownload })
                            }
                        />

                    </PanelBody>
                </InspectorControls>

                <div
                    className={`latest-posts-cta-layout bg-${backgroundGraphic}`}
                >
                    <div className="layout">

                        <div className={url ? "cta-left w-download" : "cta-left"} style={{ background: 'linear-gradient(0deg, #10783A 0%, #C1DDA5 100%)' }}>

                            <div className="text-content" style={{ zIndex: 2 }}>
                                <RichText
                                    tagName="div"
                                    className="tagline"
                                    value={tagline}
                                    placeholder="Tagline"
                                    style={{ zIndex: 1, position: 'relative', color: '#8AC53F' }}
                                    onChange={(val) =>
                                        setAttributes({ tagline: val })
                                    }
                                />

                                <RichText
                                    tagName="h2"
                                    className="title"
                                    value={title}
                                    placeholder="Title"
                                    style={{ zIndex: 1, position: 'relative', color: 'white' }}
                                    onChange={(val) =>
                                        setAttributes({ title: val })
                                    }
                                />

                                <RichText
                                    tagName="p"
                                    className="subtitle"
                                    value={subtitle}
                                    placeholder="Subtitle"
                                    style={{ zIndex: 1, position: 'relative', color: '#ddd' }}
                                    onChange={(val) =>
                                        setAttributes({ subtitle: val })
                                    }
                                />

                                {url && (
                                    <a
                                        className={`cta-icon-button ${isDownload ? "download" : ""}`}
                                        href={url}
                                        download={isDownload || undefined}
                                        style={{ color: '#10783A', textDecoration: 'none' }}

                                    >
                                        <img
                                            src={external_link_icon}
                                            className="cta-icon"
                                            alt=""
                                        />
                                    </a>
                                )}
                            </div>
                            <img
                                src={forest_bottom_graphic}
                                className="graphic-bottom"
                                alt=""
                                style={{ zIndex: 0 }}
                            />
                        </div>

                        <div className="posts-right">

                            <InnerBlocks
                                allowedBlocks={["core/latest-posts"]}
                                template={[
                                    [
                                        "core/latest-posts",
                                        {
                                            postsToShow: 4,
                                            displayFeaturedImage: true,
                                            displayPostContent: true,
                                            displayPostDate: true,
                                            postLayout: "list",
                                        },
                                    ],
                                ]}
                            />

                        </div>
                    </div>
                </div>
            </>
        );
    },

    save({ attributes }) {

        const {
            backgroundGraphic,
            title,
            subtitle,
            tagline,
            url,
            isDownload,
        } = attributes;

        return (
            <div
                className={`latest-posts-cta-layout bg-${backgroundGraphic}`}
            >
                <div className="layout">

                    <div className="cta-left" style={{ background: 'linear-gradient(0deg,#10783A 0%, #C1DDA5 65%)' }}>
                        <div className="text-content">
                            <RichText.Content
                                tagName="div"
                                className="tagline"
                                value={tagline}
                            />

                            <RichText.Content
                                tagName="h2"
                                className="title"
                                value={title}
                            />

                            <RichText.Content
                                tagName="p"
                                className="subtitle"
                                value={subtitle}
                            />

                            {url && (
                                <a
                                    className={`cta-icon-button ${isDownload ? "download" : ""}`}
                                    href={url}
                                    download={isDownload || undefined}
                                    style={{ color: '#10783A', textDecoration: 'none' }}
                                    target="_blank"

                                >
                                    <img
                                        src={external_link_icon}
                                        className="cta-icon"
                                        alt=""
                                    />
                                </a>
                            )}
                        </div>
                        <img
                            src={forest_bottom_graphic}
                            className="graphic-bottom"
                            alt=""
                        />
                    </div>
                    <div className="posts-right">
                        <InnerBlocks.Content />
                    </div>

                </div>
            </div>
        );
    },
};

registerBlockType(
    "rbt/latest-posts-cta-layout",
    latestpostscta
);

export default latestpostscta;